<template>
    <div v-loading="loading">
      <div class="type-btn-group operation-box" >
          <el-text type="primary">
            <span tkey="月結單">{{i18n.tkey("lang_month_bill")}}</span>
          </el-text>
      </div>

      <div class="padding-8">

          <el-text class="print-hide right-16"  tkey="日期選擇">{{i18n.tkey("lang_date_select")}}： </el-text>
        <input class="right-16" ref="seletdateid" v-model="seletdate" type="month" @change="changeMonthDate" />

        <el-button class="right-16" type="primary" @click="clickPrintBtn" tkey="列印">{{i18n.tkey("lang_print")}}</el-button>
        <div style="width: 100%;text-align: right">
        <el-text class="right-16" tkey="當月總參考佣金" >{{i18n.tkey('lang_month_total_bill')}}:${{bill_total}}</el-text>
        </div>
      </div>

      <div>
        <el-row :gutter="10" class="padding-8">
          <el-col
              :span="8"
              class="record-box"
          >
            <el-text >ID</el-text>

          </el-col>
          <el-col
              :span="6"
              class="record-box"
          >

            <el-text >{{i18n.tkey('lang_merchant_info')}}</el-text>

          </el-col>
          <el-col
              :span="6"
              class="record-box"
          >

            <el-text ></el-text>

          </el-col>
          <el-col
              :span="4"
              class="record-box"
          >

            <el-text >{{i18n.tkey('lang_commission_total')}}</el-text>
          </el-col>
        </el-row>
        <hr>
      </div>

      <div v-for="(value, index) in dataMonthList" :key="value.id">
        <el-row :gutter="10" class="padding-8">
          <el-col
              :span="4"
              class="record-box"
          >
            <el-text >{{value.id}}</el-text>

          </el-col>
          <el-col
              :span="4"
              class="record-box"
          >
            <el-text >{{value.name}}</el-text>

          </el-col>
          <el-col
              :span="6"
              class="record-box"
          >

            <el-text > email:{{value.email}}</el-text>

          </el-col>
          <el-col
              :span="6"
              class="record-box"
          >

            <el-text > tel:{{value.telephone}}</el-text>

          </el-col>
          <el-col
              :span="4"
              class="record-box"
          >

            <el-text >${{value.bill}}</el-text>
          </el-col>
        </el-row>
        <hr>
      <div>
        <el-row :gutter="10" class="padding-8">
          <el-col
              :span="4"
              class="record-box"
          >

          </el-col>
          <el-col
              :span="8"
              class="record-box"
          >

            <el-text >{{i18n.tkey('lang_product_information')}}</el-text>
          </el-col>
          <el-col
              :span="4"
              class="record-box"
          >

            <el-text >{{i18n.tkey('lang_commission')}}</el-text>
          </el-col>
          <el-col
              :span="4"
              class="record-box"
          >

            <el-text >{{i18n.tkey('lang_sales_volume')}}</el-text>
          </el-col>
          <el-col
              :span="4"
              class="record-box"
          >
            <el-text >{{i18n.tkey('lang_commission_payable')}}</el-text>
          </el-col>
        </el-row>
        <hr>
      </div>
        <div v-for="(value2, index) in value.boproductAgentModels" :key="value2.id">

          <el-row :gutter="10" class="padding-8">
            <el-col
                :span="4"
                class="record-box"
            >

            </el-col>
            <el-col
                :span="8"
                class="record-box"
            >
              <div style="display: flex">
                <img width="60px" height="60px" :src="myUtil.generateProductImg(value2, imgRandomNum)" style="width: 60px; height: 60px;display: inline-block;vertical-align:baseline">
                <div style="padding-left: 10px;">

                  <el-text >{{value2.productid}}:</el-text>
                  <el-text >{{value2.productname}}</el-text>
                  <br>
                  <el-text >{{i18n.tkey('lang_selling_price')}}:${{value2.cost}}</el-text>
                  <br>
                  <el-text >{{i18n.tkey('lang_buyer_login')}}:{{value2.login}}</el-text>
                  <br>
                  <el-text >{{i18n.tkey('lang_buyer_name')}}:{{value2.name}}</el-text>

                </div>
              </div>
            </el-col>
            <el-col
                :span="4"
                class="record-box"
            >

              <el-text >${{value2.pocost}}({{value2.percent}}%)</el-text>
            </el-col>
            <el-col
                :span="4"
                class="record-box"
            >
              <el-text >{{value2.qty}}</el-text>

            </el-col>
            <el-col
                :span="4"
                class="record-box"
            >

              <el-text type="primary" >${{value2.tqty1}}</el-text>

            </el-col>
          </el-row>
          <hr>
        </div>
      </div>


<!--        <PaginationComponent :pageObj="pageObj" @goPage="clickGoPage" />-->
    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount, getCurrentInstance, toRef} from "vue";
import myUtil from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";
import boProductApi from "@/request/boProductApi";
import util from "@/util/util";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const props = defineProps(["dataMonthList"])
const { proxy } = getCurrentInstance()

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

const loading = ref(false)
const dataMonthList = ref([])

const seletdate = ref(util.formatDate(new Date(), 'yyyy-MM'));



const bill_total = ref(0.00)



onBeforeMount(() => {
  changeMonthDate()
})

const boProductrequest = boProductApi.queryMonthBill
const boProductparams = boProductrequest.getParams()
      boProductparams.lastmodifieddate = ""
      boProductparams.verify = -1
function getMonthBillList(){
  loading.value = true
  boProductparams.descriptionc4 = userInfoRef.value.id
  boProductrequest.send(boProductparams, (res) => {
    loading.value = false
    if (res.code == 200){
      dataMonthList.value = res.detail
      dataMonthList.value.forEach(function (value) {
        bill_total.value += value.bill
      });
    }else{
      myUtil.alertError(res.msg)
    }
  })

}
function clickPrintBtn(){

}

function changeMonthDate(){
  if (seletdate.value != null) {
    boProductparams.lastmodifieddate = seletdate.value.substr(0, 4) + "/" + seletdate.value.substr(-2, 2)

    getMonthBillList()
  }
}



</script>


<style scoped>
.type-btn-group {
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 8px;
}

.operation-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.padding-8{
  padding: 8px;
}

.right-16{
  margin-right: 16px;
}

</style>